iScreenWizard.factory('Opleidingsgroep', function ($q, Ajax) {

    var data = {};

    data.all = function() {
        return $q(function (resolve, reject) {
            Ajax.get('opleidingsgroep').then(function (response) {
                var opleidingsgroepen = response.data;
                resolve(opleidingsgroepen);
            }, reject);
        });
    };

    data.get = function(id) {
        return $q(function (resolve, reject) {
            Ajax.get('opleidingsgroep/'+id).then(function (response) {
                var opleidingsgroep = response.data;
                resolve(opleidingsgroep);
            }, reject);
        });
    };

    return data;
});